const close = (force, reason) => {
    if (!window.OPLWCParent) {
        document.addEventListener('WCCParentLoaded', () => {
            window.OPLWCParent.close(force, reason);
            window.com = null;
        });
    } else {
        window.OPLWCParent.close(force, reason);
        window.com = null;
    }
};

export { close };
